<template>
  <div>
    <div class="column column-one">
      <vehicle-meta :quote="quote" :driverGradesById="driverGradesById"/>

      <vehicle-image :derivative="quote.derivative" :showMain="true" :showThumbs="true" enableGallery="true"/>

      <estimated-electric-costs
        v-if="(fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription))"
        :quote="quote" :averagePencePerMile="averagePencePerMile" />
      <mpg-slider v-else-if="showMpgSliderIfApplicable" :quote="quote" :default-mpg="quote.derivedMPG" />

      <div v-if="quote.derivative.primaryTechnicalItems">
        <comparison-additional :derivative="quote.derivative" :p11dValue="quote.quote.details.pricing.p11DValue"
          :quote="quote"/>
      </div>
    </div>

  </div>
</template>

<script>
import EstimatedElectricCosts from "@/components/car-comparison/estimated-electric-costs";
import MpgSlider from "@/components/car-comparison/mpg-slider";
import AdditionalData from '@/components/car-comparison/comparison-additional';
import VehicleImage from "@/components/vehicle-details/vehicle-image";
import VehicleMeta from "@/components/car-comparison/vehicle-meta.vue";
import ComparisonAdditional from "@/components/car-comparison/comparison-additional";

export default {
  name: "side-by-side",
  components: { MpgSlider, EstimatedElectricCosts, VehicleImage, AdditionalData, VehicleMeta, ComparisonAdditional },
  props: [
    'quote',
    'sideBySide',
    'averagePencePerMile',
    'showMpgSliderIfApplicable',
    'fuelTypeElectricOrPluginHybrid',
    'driverGradesById',
  ]
}
</script>

<style scoped>

</style>
